<template>
    <main class="main">
        <div class="container-fluid px-0" data-layout="container">

            <aside-main/>

            <header-main/>

            <div class="content">

                <div class="card-header mb-5 d-flex flex-between-center">
                    <div class="d-flex align-items-center">
                        <h2>Главная</h2>
                    </div>
                </div>

                <div class="card-body p-0 spinner-center" v-if="preloader">
                    <div class="p-4 code-to-copy">
                        <div class="spinner-border" role="status"></div>
                    </div>
                </div>

                <div class="row g-5" v-if="!preloader">
                    <div class="col-xl-12 mb-5">
                        <form class="row g-3" v-on:submit.prevent="update">

                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input
                                        v-model="data.name"
                                        @input="errors.name = null"
                                        :class="{'is-invalid': errors.name}"
                                        placeholder="Название"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Название</label>
                                    <div class="invalid-feedback">{{errors.name}}</div>
                                </div>
                            </div>

                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input
                                        v-model="data.balance"
                                        @input="errors.balance = null"
                                        :class="{'is-invalid': errors.balance}"
                                        placeholder="Баланс"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Баланс</label>
                                    <div class="invalid-feedback">{{errors.balance}}</div>
                                </div>
                            </div>

                            <div class="card-header p-2 mt-4 d-flex flex-between-center" style="margin-bottom: -10px;">
                                <div class="d-flex align-items-center">
                                    <h2 class="fs-1">Монеты</h2>
                                </div>

                                <div class="d-flex">
                                    <a 
                                        @click="newCoin"
                                        class="btn btn-primary mb-1 float_right">Новая монета</a>
                                </div>
                            </div>

                            <template v-for="(item, index) in data.coins">
                                <div class="col-sm-6 col-md-1">
                                    <div class="form-floating">
                                        <input
                                            v-model="data.coins[index].ticker"
                                            placeholder="Тикер"
                                            class="form-control" 
                                            type="text"/>
                                        <label>Тикер</label>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-md-2">
                                    <div class="form-floating">
                                        <input
                                            v-model="data.coins[index].blockhain"
                                            placeholder="Сеть"
                                            class="form-control" 
                                            type="text"/>
                                        <label>Сеть</label>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-md-1">
                                    <div class="form-floating">
                                        <input
                                            v-model="data.coins[index].balance"
                                            placeholder="Баланс"
                                            class="form-control" 
                                            type="text"/>
                                        <label>Баланс</label>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-md-1">
                                    <div class="form-floating">
                                        <input
                                            v-model="data.coins[index].balance_usd"
                                            placeholder="Баланс в $"
                                            class="form-control" 
                                            type="text"/>
                                        <label>Баланс в $</label>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-md-1">
                                    <div class="form-floating">
                                        <input
                                            v-model="data.coins[index].rate"
                                            placeholder="Курс"
                                            class="form-control" 
                                            type="text"/>
                                        <label>Курс</label>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-md-1">
                                    <div class="form-floating">
                                        <input
                                            v-model="data.coins[index].percent"
                                            placeholder="%"
                                            class="form-control" 
                                            type="text"/>
                                        <label>%</label>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-md-5">
                                    <div class="form-floating v-select-medium select-both-button-row">
                                        <div 
                                            @click="$refs.uploadCoinImage.click()"
                                            content="Загрузить новое изображение" 
                                            v-tippy="{arrow : true, arrowType: 'round'}"
                                            class="select-button-left">
                                            <span class="vertical-center-icon">
                                                <i class="fa-solid fa-plus"></i>
                                            </span>
                                        </div>
                                        <div>
                                            <vue-select
                                                v-model="data.coins[index].image"
                                                :options="utils.images.coins" 
                                                placeholder="Изображение">
                                                <template v-slot:option="option">
                                                    <img style="width: 100px;margin-right: 20px;height: 100%;" :src="`${$config.ApplicationPublicURL}/img/trustwallet/home/coins/${option.label}`"/>
                                                    <a 
                                                        @click="deleteImageCoin(option.label)"
                                                        content="Удалить" 
                                                        v-tippy="{arrow : true, arrowType: 'round'}"
                                                        class="btn btn-sm btn-soft-danger ms-2" 
                                                        style="position: absolute; right: 1rem;">
                                                        <i class="fa-regular fa-trash"></i>
                                                    </a>
                                                </template>
                                                <template v-slot:no-options="{ search, searching }">
                                                  <template v-if="searching">
                                                     Ничего не найдено по запросу <em>{{ search }}</em>.
                                                  </template>
                                                </template>
                                            </vue-select>
                                            <label class="custom-select-label">Изображение</label>
                                        </div>

                                        <button
                                            @click="changeCoinStatus(index)"
                                            :content="data.coins[index].status == 1 ? 'Отключить' : 'Включить'" 
                                            v-tippy="{arrow : true, arrowType: 'round'}"
                                            type="button"
                                            class="btn btn-soft-secondary select-button-right">
                                            <span class="vertical-center-icon">
                                                <i class="icon-paysystem fa-regular" :class="{'fa-circle-pause': data.coins[index].status == 1, 'fa-play': data.coins[index].status == 0}"></i>
                                            </span>
                                        </button>

                                        <button
                                            :disabled="data.coins.length == 1"
                                            @click="deleteCoin(index)"
                                            content="Удалить" 
                                            v-tippy="{arrow : true, arrowType: 'round'}"
                                            type="button"
                                            class="btn btn-soft-danger select-button-right-2">
                                            <span class="vertical-center-icon">
                                                <i class="icon-paysystem fa-regular fa-trash"></i>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </template>

                            <input ref="uploadCoinImage" type="file" @input="uploadImageCoins" accept=".png, .jpg, .jpeg, .gif, .svg" style="display: none;">


                            <div class="col-sm-3 col-md-3">
                                <button class="btn btn-primary px-5 w-100 text-nowrap" type="submit" :class="{'disabled': btn_preloader}">
                                    <span class="spinner-border spinner-border-sm spinner-border-custom" role="status" v-if="btn_preloader"></span>
                                    <span>Сохранить</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                
                <footer-main/>

            </div>

        </div>
    </main>
</template>

<script>
export default {
    props: ['id'],
    data () {
        return {
            preloader: true,
            btn_preloader: false,
            data: {
                name: null,
                balance: null,
                coins: [
                    {
                        ticker: null,
                        blockhain: null,
                        balance: null,
                        balance_usd: null,
                        rate: null,
                        percent: null,
                        image: null,
                        status: 1
                    }
                ]
            },
            errors: {
                name: false,
                balance: false,
                coins: [
                    {
                        ticker: false,
                        blockhain: false,
                        balance: false,
                        balance_usd: false,
                        rate: false,
                        percent: false,
                        image: false,
                        status: false
                    }
                ]
            },
            utils: {
                images: {
                    coins: []
                }
            }
        }
    },
    methods: {
        getItem () {
            this.$axios.post('/trustwallet/item/home')
            .then(async (response) => {
                this.preloader = false
                response = response.data
                switch (response.status) {
                    case 'error':
                        this.$toast.error(response.message)
                        break
                    case 'success':

                        this.data = response.data

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })     
        },
        update () {
            this.btn_preloader = true
            this.$axios.post('/trustwallet/home/update', JSON.stringify(this.data))
            .then((response) => {
                this.btn_preloader = false
                response = response.data
                switch (response.status) {
                    case "error":
                        this.$toast.error(response.message)
                        break
                    case "success":
                        this.$toast.success(response.message)

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                this.btn_preloader = false
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    if('field' in response) {
                        this.errorByPatch(this.errors, response.field, response.message)
                    } else {
                        this.$toast.error(response.message)
                    }
                }
            })
        },
        getImagesCoins () {
            this.$axios.post('/trustwallet/home/coins/images/items')
            .then((response) => {
                response = response.data
                switch (response.status) {
                    case 'error':
                        this.$toast.error(response.message)
                        break
                    case 'success':
                        this.utils.images.coins = response.data

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })     
        },
        uploadImageCoins (e) {
            var formData = new FormData()
            formData.append("image", e.target.files[0])

            this.$confirm('Вы уверены что хотите загрузить это изображение?').then(() => {
                this.$axios.post('/trustwallet/home/coins/images/upload', formData)
                .then((response) => {
                    response = response.data
                    switch (response.status) {
                        case 'error':
                            this.$toast.error(response.message)
                            break
                        case 'success':
                            this.getImagesCoins()
                            this.$toast.success(response.message)

                            this.setUser(response.user)
                            break
                        default:
                            this.$toast.error('Unknown error')
                    }
                }).catch((error) => {
                    let response = error.response.data
                    this.setUser(response.user)

                    if('status' in response && response.status == 'error') {
                        this.$toast.error(response.message)
                    }
                })  
            })
        },
        deleteImageCoins (image) {
            this.$confirm('Вы уверены что хотите удалить это изображение?').then(() => {
                this.$axios.post('/trustwallet/home/coins/images/delete', JSON.stringify({
                    image: image
                }))
                .then((response) => {
                    response = response.data
                    switch (response.status) {
                        case 'error':
                            this.$toast.error(response.message)
                            break
                        case 'success':
                            this.getImagesCoins()
                            this.$toast.success(response.message)

                            this.setUser(response.user)
                            break
                        default:
                            this.$toast.error('Unknown error')
                    }
                }).catch((error) => {
                    let response = error.response.data
                    this.setUser(response.user)

                    if('status' in response && response.status == 'error') {
                        this.$toast.error(response.message)
                    }
                })  
            })
        },
        errorByPatch (layer, path, value) {
            path = path.split('.')

            path.forEach((value, index) => {
                if (!isNaN(value)) {
                    path[index] = parseInt(value)
                }
            })

            for (var i = 0; i < path.length; i++) {
                if (value != null && i + 1 === path.length) {
                    layer[path[i]] = value
                }
                layer = layer[path[i]]
            }
            return layer
        },
        newCoin () {
            this.data.coins.push({
                ticker: null,
                blockhain: null,
                balance: null,
                balance_usd: null,
                rate: null,
                percent: null,
                image: null,
                status: 1
            })

            this.errors.coins.push({
                ticker: false,
                blockhain: false,
                balance: false,
                balance_usd: false,
                rate: false,
                percent: false,
                image: false,
                status: false
            })
        },
        deleteCoin (index) {
            if(this.data.coins.length > 1) {
                this.data.coins.splice(index, 1)
            }
        },
        changeCoinStatus (index) {
            this.data.coins[index].status = this.data.coins[index].status ? 0 : 1
        }
    },
    beforeMount() {
        this.getItem()
        this.getImagesCoins()
    }
}
</script>

<style lang="css" scoped>
    ::v-deep .vs__clear {
        display: none;
    }
</style>
